import type { ApiErrorResponse } from '@libs/data-access/queries'
import { AlertErrorAdapter, Center, Loader } from '@libs/ui/ds'
import type { UseQueryResult } from '@tanstack/react-query'
import type { FC } from 'react'
import React from 'react'

type Props = {
  statuses?: UseQueryResult['status'][]
  errors?: (ApiErrorResponse | null)[]
  className?: string
  overlay?: boolean
}

export const QueriesRequestsStatus: FC<Props> = ({
  overlay,
  statuses,
  errors,
  className
}) => {
  const atLeastOnePending = statuses?.find(status => status === 'pending')

  if (atLeastOnePending) {
    return overlay ? (
      <Loader.Overlay className={className} />
    ) : (
      <Center className={`h-full ${className}`}>
        <Loader className={className} />
      </Center>
    )
  }

  const atLeastOneError = statuses?.find(status => status === 'error')

  if (atLeastOneError) {
    return errors?.map((error, idx) => (
      <AlertErrorAdapter
        key={`err-${Math.random()}-${idx}`}
        className={className}
        error={error?.error}
      />
    ))
  }

  return null
}
